import React, { useCallback, useEffect, useState } from 'react';
import { useRouteAnnouncer } from '../hooks/useRouteAnnouncer.js';

export function RouteAnnouncer({ updateDocumentTitle = false, formatTitle }) {
  const [title, setTitle] = useState('');

  const getTitle = useCallback((location) => {
    if (typeof document === 'undefined') return 'Page';
    return document.title || (location && location.pathname) || 'Page';
  }, []);

  useRouteAnnouncer(getTitle);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const onChange = (e) => {
      const next = e && e.detail && e.detail.title ? e.detail.title : 'Page';
      setTitle(next);
      if (updateDocumentTitle && typeof document !== 'undefined') {
        const formatted = typeof formatTitle === 'function' ? formatTitle(next) : next + ' | ICFC Finance Ltd.';
        try { document.title = formatted; } catch (err) {  }
      }
    };
    window.addEventListener('a11y:route-change', onChange);
    return () => window.removeEventListener('a11y:route-change', onChange);
  }, [updateDocumentTitle, formatTitle]);

  return (
    <div className="a11y-route-announcer" role="status" aria-live="polite" aria-atomic="true">
      {title}
    </div>
  );
}

export default RouteAnnouncer;
